export { FundsPage } from './funds';
export { AboutUsPage } from './about_us';
export { PortfoliosPage } from './portfolios';
export { AssetsPage } from './assets';
